module.exports = __webpack_public_path__ + "static/media/stepFour.36f603c6.png";